// checkoutSelectors.js
import { createSelector } from '@reduxjs/toolkit';

const selectCartItems = (state) => state.cart.items || [];

export const selectOrderSummary = createSelector(
  [selectCartItems],
  (items) => {
    const subtotal = items.reduce((acc, item) => {
      const priceCOP = parseFloat(item.priceCOP || 0);
      return acc + priceCOP * item.quantity;
    }, 0);

    const shipping = subtotal > 0 ? 35000 : 0; // valor fijo o calculado en COP
    const taxes = subtotal * 0.19;             // 19% de IVA si aplica
    const total = subtotal + shipping + taxes;

    return {
      subtotal,
      shipping,
      taxes,
      total,
    };
  }
);


export const selectSubtotal = createSelector(
  [selectCartItems],
  (items) => {
    return items.reduce((acc, item) => {
      const priceCOP = parseFloat(item.priceCOP || 0);
      const quantity = item.quantity || 0;
      return acc + priceCOP * quantity;
    }, 0);
  }
);

